import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LiveTrackingComponent } from './LiveTracking.component';
import { ResetPasswordComponent } from './../components/custompassword/resetpassword.component';

const routes: Routes = [
    { path: '', component: LiveTrackingComponent },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class LiveTrackingRoutingModule {
}